<template>
  <div class="IncreaseProductName">
    <el-dialog
      title="添加物品品名"
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="beforeCloseComponents"
    >
      <el-form
        class="custom-formItem"
        ref="formData"
        label-width="100px"
        inline
        :model="formData"
        :rules="rulesFormData"
      >
        <el-form-item label="物品类目" prop="categoryId">
          <el-select v-model="formData.categoryId" placeholder="请选择">
            <el-option
              v-for="item in listProductCategory"
              :key="item.id"
              :label="item.categoryName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item></el-form-item>
        <el-form-item></el-form-item>
        <el-form-item label="中文品名" prop="chineseName">
          <el-input v-model="formData.chineseName" placeholder="请输入中文品名"></el-input>
        </el-form-item>
        <el-form-item label="英文品名" prop="englishName">
          <el-input v-model="formData.englishName" placeholder="请输入英文品名"></el-input>
        </el-form-item>
        <el-form-item label="海关编号" prop="customsNo">
          <template slot="label">
            <el-link
              href="https://www.hsbianma.com/"
              target="_blank"
              type="primary"
              :underline="false"
            >海关编号</el-link>
          </template>
          <el-input v-model="formData.customsNo" placeholder="请输入海关编号"></el-input>
        </el-form-item>
      </el-form>

      <el-row type="flex" justify="end" style="margin-bottom: 20px;">
        <el-button type="primary" @click="handleIncrease" :loading="loadingIncrease">添加</el-button>
      </el-row>

      <el-table :data="listTable" border size="small">
        <el-table-column prop="categoryName" align="center" label="物品类目"></el-table-column>
        <el-table-column prop="chineseName" align="center" label="中文品名"></el-table-column>
        <el-table-column prop="englishName" align="center" label="英文品名"></el-table-column>
        <el-table-column prop="customsNo" align="center" label="海关编号"></el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="primary" @click="openInnerEdit(scope.row)">编辑</el-button>
            <el-button type="danger" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-dialog
        title="编辑物品品名"
        :visible.sync="dialogVisibleInner"
        width="30%"
        :before-close="beforeCloseInnerDialog"
        append-to-body
      >
        <el-form
          ref="formDataInner"
          label-width="100px"
          :model="formDataInner"
          :rules="rulesFormDataInner"
        >
          <el-form-item label="中文品名" prop="chineseName">
            <el-input v-model="formDataInner.chineseName" placeholder="请输入中文品名"></el-input>
          </el-form-item>
          <el-form-item label="英文品名" prop="englishName">
            <el-input v-model="formDataInner.englishName" placeholder="请输入英文品名"></el-input>
          </el-form-item>
          <el-form-item label="海关编号" prop="customsNo">
            <template slot="label">
              <el-link
                href="https://www.hsbianma.com/"
                target="_blank"
                type="primary"
                :underline="false"
              >海关编号</el-link>
            </template>
            <el-input v-model="formDataInner.customsNo" placeholder="请输入海关编号"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button type="primary" @click="handleEdit" :loading="loadingEdit">完 成</el-button>
        </div>
      </el-dialog>
    </el-dialog>
  </div>
</template>

<script>
import { ajaxPost, Baseurl } from '@/api/api/api'

export default {
  name: 'IncreaseProductName',
  data() {
    return {
      dialogVisible: false,
      formData: {
        chineseName: '',
        englishName: '',
        customsNo: '',
        categoryId: ''
      },
      rulesFormData: {
        chineseName: [
          { required: true, message: '请输入中文品名', trigger: 'blur' }
        ],
        englishName: [
          { required: true, message: '请输入英文品名', trigger: 'blur' }
        ],
        customsNo: [
          { required: true, message: '请输入海关编号', trigger: 'blur' }
        ],
        categoryId: [
          { required: true, message: '请输入物品类目', trigger: 'blur' }
        ],
      },
      listTable: [],
      loadingIncrease: false,
      listProductCategory: [],

      dialogVisibleInner: false,
      formDataInner: {},
      rulesFormDataInner: {},
      loadingEdit: false
    }
  },
  methods: {
    initComponents() {
      this.dialogVisible = true

      this.getListProductCategory()
      this.getListTable()
    },
    beforeCloseComponents(done) {
      this.loadingIncrease = false
      this.$refs.formData.resetFields()
      this.$refs.formData.clearValidate()
      done()
    },
    handleIncrease() {
      this.$refs.formData.validate((valid) => {
        if (!valid) return
        const API = Baseurl + 'logisticsConfigurationController/insertLogisticsProductName'
        const paramsData = this.formData
        this.loadingIncrease = true

        ajaxPost(API, paramsData).then(res => {
          const { code } = res.data
          this.loadingIncrease = false
          if (code === 200) {
            this.$refs.formData.resetFields()
            this.$message.success('操作成功！')
            this.getListTable()
          }
        })
      })
    },
    handleDelete(row) {
      this.$confirm('确定要删除该物品名称数据吗？', '提示')
        .then(() => {
          const API = Baseurl + 'logisticsConfigurationController/deleteLogisticsProductName'
          const paramsData = {
            id: row.id
          }

          ajaxPost(API, paramsData).then(res => {
            const { code, data } = res.data
            if (code === 200) {
              this.$message.success('操作成功！')
              this.getListTable()
            } else if (code === 500) {
              this.$message.error(data)
            } else {
              this.$message.error('操作失败！')
            }
          })
        })
    },
    getListTable() {
      const API = Baseurl + 'logisticsConfigurationController/selectLogisticsProductNameList'

      ajaxPost(API).then(res => {
        const { code, data } = res.data
        if (code === 200) {
          this.listTable = data
        }
      })
    },
    getListProductCategory() {
      const API = Baseurl + 'logisticsConfigurationController/selectLogisticsCategoryList'

      ajaxPost(API).then(res => {
        const { code, data } = res.data
        if (code === 200) {
          this.listProductCategory = data
        }
      })
    },

    openInnerEdit(row) {
      this.dialogVisibleInner = true
      this.formDataInner = JSON.parse(JSON.stringify(row))
    },
    beforeCloseInnerDialog(done) {
      this.loadingEdit = false
      this.$refs.formDataInner.resetFields()
      this.$refs.formDataInner.clearValidate()
      done()
    },
    handleEdit() {
      const API = Baseurl + 'logisticsConfigurationController/updateLogisticsProductName'
      const paramsData = this.formDataInner
      this.loadingEdit = true

      ajaxPost(API, paramsData).then(res => {
        const { code } = res.data
        this.loadingEdit = false
        if (code === 200) {
          this.dialogVisibleInner = false
          this.$message.success('操作成功！')
          this.getListTable()
        }
      })
    }
  }
}
</script>
